export const SmallLogo = ({ className = "", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 699 699"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="349.5" cy="349.5" r="349.5" fill="#FAEDCA" />
    <path
      d="M578.517 235.795H112.063C104.732 235.795 98.7896 241.484 98.7896 248.501C98.7896 255.519 104.732 261.207 112.063 261.207H578.517C585.847 261.207 591.79 255.519 591.79 248.501C591.79 241.484 585.847 235.795 578.517 235.795Z"
      fill="#FCB826"
    />
    <path
      d="M485.065 205.3C471.557 141.446 414.102 93.4858 345.297 93.4858C276.492 93.4858 219.036 141.446 205.529 205.3H485.065Z"
      fill="#FCB826"
    />
    <path
      d="M586.48 355.345C586.48 355.345 451.702 328.81 385.112 394.7C363.03 416.535 351.277 498.999 345.313 528.355C339.393 498.999 327.597 416.535 305.515 394.7C238.969 328.852 104.147 355.345 104.147 355.345C104.147 355.345 77.3121 488.622 143.945 554.469C210.535 620.317 345.313 593.824 345.313 593.824C345.313 593.824 480.092 620.36 546.682 554.469C613.272 488.622 586.48 355.345 586.48 355.345Z"
      fill="#008B09"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M287.705 325.904C297.264 325.904 305.012 314.834 305.012 301.179C305.012 287.523 297.264 276.453 287.705 276.453C283.659 276.453 279.938 278.436 276.991 281.758C279.052 283.614 280.415 286.837 280.415 290.501C280.415 296.252 277.058 300.914 272.917 300.914C272.037 300.914 271.192 300.704 270.407 300.317C270.4 300.603 270.397 300.89 270.397 301.179C270.397 314.834 278.146 325.904 287.705 325.904Z"
      fill="#008B09"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M398.521 325.904C408.08 325.904 415.829 314.834 415.829 301.179C415.829 287.523 408.08 276.453 398.521 276.453C394.476 276.453 390.754 278.436 387.807 281.758C389.868 283.614 391.231 286.837 391.231 290.501C391.231 296.252 387.874 300.915 383.733 300.915C382.853 300.915 382.008 300.704 381.224 300.317C381.217 300.603 381.213 300.89 381.213 301.179C381.213 314.834 388.962 325.904 398.521 325.904Z"
      fill="#008B09"
    />
    <path
      d="M576.642 521.792C549.144 602.851 407.194 603.885 342.935 594.268C335.628 566.096 329.983 489.235 365.851 407.159C401.72 325.083 535.232 334.262 597.505 349.111C599.822 372.898 604.139 440.733 576.642 521.792Z"
      fill="#FF7A34"
    />
    <path
      d="M305.385 549.995C282.615 516.673 221.08 440.699 157.102 403.379"
      stroke="white"
      strokeWidth="7.42512"
      strokeLinecap="round"
    />
    <path
      d="M377.86 549.995C395.002 522.732 441.325 460.571 489.488 430.036"
      stroke="white"
      strokeWidth="7.42512"
      strokeLinecap="round"
    />
  </svg>
);
